<template>
	<div id="voiceSceneDetail">
    <div class="top">
    	<a class="btn-end" @click="endScene">结束考核</a>
    </div>
    <div class="hawkeye">
    	<div class="left">
    		<div class="iframe-box">
					<iframe src="/hawkeyeVue/#/service/index" width="100%" height="100%" frameborder="0"></iframe>
  			</div>
    	</div>
    	<div class="right">
    		<div class="header">考核得分与建议</div>
    		<div class="content">
    			<template v-if="isHasData">
    				<template v-if="gradeState == 1">
							<!--打分中-->
		    			<p><img src="@/assets/images/voiceScene/icon_dafen.png" /></p>
		    			<p>讲师正在对你的考核打分</p>
		    			<p>预计需要3分钟，请稍等…</p>
    				</template>
    				<template v-if="gradeState == 2">
    					<template v-if="effectStatus == 0">
	    					<!--无效练习-->
			    			<p><img src="@/assets/images/voiceScene/icon_wuxiao.png" /></p>
			    			<p>本次考核无效</p>
			    			<p v-if="isCurrent">你还有1次考核机会</p>
			    			<p class="wuxiao">{{ effectReason }}</p>
		    			</template>
		    			<template v-if="effectStatus == 1">
			    			<!--评分结果-->
			    			<div class="video">
			    				<span>考核录音</span>
									<audio :src="videoUrl" controls="controls"></audio>
								</div>
								<div class="score">
									<div class="title" style="justify-content: space-between;">
										<div>
											<span>考核结果</span>
											<span :class="{'blue': passedStatus, 'red': !passedStatus}">{{ gradeScore }}分</span>
										</div>
										<div v-if="passedStatus" :class="{'blue': passedStatus, 'red': !passedStatus}">已通过，请尽快完成结业课</div>
										<div v-else :class="{'blue': passedStatus, 'red': !passedStatus}">没有通过考核，需要继续加油哦</div>
									</div>
									<div class="grade" v-for="(f, index) in gradeList">
										<div class="first">
											<span class="name">{{ f.name }}</span>
											<span class="blue gradescore">{{ f.gradeScore }}分</span>
										</div>
										<div class="second" v-for="(s, key) in f.childList">
											<div class="parent">
												<span class="name">{{ s.name }}</span>
												<span class="red gradescore">{{ s.gradeScore < 0 ? s.gradeScore : '-'+(s.score - s.gradeScore)}}分</span>
												<span :class="{'el-icon-arrow-right': !s.isClickSecond, 'el-icon-arrow-down': s.isClickSecond}" @click="clickSecond(index, key)" :key="key+keyData"></span>
											</div>
											<div :class="{'third': true, 'none': !s.isClickSecond}" :key="key+keyData" v-for="(t, key) in s.childList">
												<span class="name">{{ t.name }}</span>
												<span class="red gradescore">{{ t.gradeScore }}分</span>
											</div>
										</div>
									</div>
								</div>
								<div class="evaluate">
									<div class="title">
										<span>讲师建议</span>
									</div>
									<p v-for="(e, key) in evaluateList">
										<span class="dot"></span>
										{{ key+1 }}、{{ e }}
									</p>
								</div>
							</template>
    				</template>
    			</template>
    			<template v-else>
    				<!--初始化-->
	    			<p><img src="@/assets/images/voiceScene/icon_kong.png" /></p>
	    			<p>完成本次考核后</p>
	    			<p>讲师将为你本次的考核打分</p>
    			</template>
    		</div>
    	</div>
    </div>
    <div class="confirmbox-bg" v-if="gradeState == 1"></div>
    <div class="confirmbox" v-if="gradeState == 1">
    	<div class="head">
    		<span class="tip">提示</span>
    		<span class="el-icon-close"></span>
    	</div>
    	<div class="text">
    		<p><img src="@/assets/images/voiceScene/icon_tips.png" /></p>
    		<p>讲师正在对你的考核打分，请耐心等待~</p>
    	</div>
    </div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				id: this.$route.query.id,
				callId: '',
				orderId: '',
				startDate: '',
				endDate: '',
				shopId: '',
				accounts: '',
				dialogVisible: false,
				isDaka: false, //是否打卡
				isHasData: null, //是否打分完成
				videoUrl: '', //录音文件
				gradeState: '', //评分状态
				passedStatus: null, //考核是否通过
				effectStatus: null, //是否有效
				effectReason: '', //无效原因
				gradeScore: '', //得分
				gradeList: '', //点评内容
				evaluateList: [], //练习建议
				isCurrent: false, //是否显示考核次数
				keyData: 0, //更新页面
				timer: null //定时获取评分状态
			}
		},
		watch: {
			gradeState: function() {
				let self = this;
				if(this.gradeState == 1) {
					this.timer = setInterval(function() {
						self.queryGrade('one');
		      }, 5000);
				}else if(this.gradeState == 2) {
          clearInterval(this.timer);
        }
			}
		},
		created() {
			window.getCallId = this.getCallId;
		},
		mounted() {
			//this.queryGrade();
		},
		methods: {
			//接收callId
			getCallId(id) {
				console.log('传进来的callId------'+id)
				this.callId = id;
				this.queryGrade();
			},
			//查询评分结果
			queryGrade(type) {
				let self = this;
				let data = {
					'callId': this.callId
				}
				this.$http.post(API_ROOT.college + '/voiceExerciseCustomer/queryExamGrade', data).then(response=>{
					var result = response.data;
					if(result.success) {
						if(result.data == null) {
							this.isHasData = false;
						}else {
							this.isHasData = true;
							this.videoUrl = result.data.videoUrl;
							this.passedStatus = result.data.passedStatus;
							this.gradeState = result.data.gradeState;
							this.effectStatus = result.data.effectStatus;
							if(type == 'one') {
								this.isCurrent = true;
							}else {
								this.isCurrent = false;
							}
							this.effectReason = result.data.effectReason;
							this.gradeScore = result.data.gradeScore;
							this.gradeList = result.data.gradeList;
							this.evaluateList = result.data.evaluateList;
							if(this.gradeList != null) {
								this.gradeList.map((item) => {
									item.childList.map((obj) => {
										obj.isClickSecond = false;
									})
								})
							}
						}
					}else{
						this.$alert(result.msg);
					}
				},response => {
					this.$alert('AJAX访问接口异常！');
				})
			},
			//点击二级菜单
			clickSecond(index, key) {
				this.$set(this.gradeList[index].childList[key], 'isClickSecond', !this.gradeList[index].childList[key].isClickSecond);
				this.keyData+=1;
			},
			endHawkeye() {
				this.$http.get('http://127.0.0.1:26789/api/npg/stop').then(response=> {
	        var result = response.data;
	        if(result.success) {
	          
	        }
	      },response=> {
	        
	      })
			},
			//结束练习
			endScene() {
				this.$confirm('是否确定结束考核?', '提示', {
	        confirmButtonText: '确定',
	        cancelButtonText: '取消',
	        type: 'warning'
	      }).then(() => {
	      	this.$http.post(API_ROOT.college + '/voiceExerciseCustomer/endExamExercise').then(response=>{
						var result = response.data;
						if(result.success) {
							this.endHawkeye();
							window.open('about:blank', '_top').close();
						}else{
							this.$alert(result.msg);
						}
					},response => {
						this.$alert('AJAX访问接口异常！');
					})
	      }).catch(() => {
	                 
	      })	
			}
		}
	}
</script>


// WEBPACK FOOTER //
// ./src/page/newVoiceScene/kaoheDetail.vue